import BaseFilterModel from "./BaseFilterModel";
import { computed } from "mobx";
import isFunction from "lodash/isFunction";
import isNull from "lodash/isNull";

class CheckboxFilterModel extends BaseFilterModel {
    get key() {
        return this.columnName;
    }

    get label() {
        return this.definition.label;
    }

    get checkboxValue() {
        return this.definition.checkboxValue;
    }

    @computed
    get func() {
        return rowData => {
            const rowValue = rowData.get(this.columnName);
            if (isFunction(this.definition.compareFunction)) {
                return this.definition.compareFunction(rowValue, this.value, rowData);
            } else {
                return !isNull(rowValue) && rowValue.toString().toLowerCase() === this.value.toLowerCase();
            }
        };
    }
}

export default CheckboxFilterModel;
